import { useEffect } from "react";

import { LEGAL_SECTIONS } from "../config/legal";
import { BOOKS, pageTitle } from "../config/site";

export function LegalPage() {
  useEffect(() => {
    document.title = pageTitle("Legal");
  }, []);

  return (
    <div className="landing legal-page">
      <h1 className="landing-title">Legal</h1>
      {LEGAL_SECTIONS.map((section) => (
        <section key={section.heading}>
          <h2 className="book-section-title">{section.heading}</h2>
          <p>{section.text}</p>
        </section>
      ))}
      <section>
        <h2 className="book-section-title">Credits</h2>
        {BOOKS.map((book) => (
          <p key={book.id}><strong>{book.title}.</strong> {book.credit}</p>
        ))}
      </section>
    </div>
  );
}
